import {CurrencyConverter} from "../converters/CurrencyConverter";
import {MassConverter} from "../converters/MassConverter";
import {defaultRecipe} from "../../global/defaults";
import {RecipeParser} from "../parsers/RecipeParser";

interface RecipeModelProps {
    recipe?: Recipe,
    formData?: any
}

export class RecipeModel {
    private currencyConverter = new CurrencyConverter()
    private massConverter = new MassConverter()
    private recipeParser = new RecipeParser()
    public recipe: Recipe

    constructor({recipe, formData}: RecipeModelProps) {
        this.recipe = defaultRecipe
        if (recipe) {this.recipe = recipe; return}
        if (formData) this.setRecipeFromFormData(formData)
    }

    public setRecipeFromFormData(formData: any) {
        this.recipe = this.recipeParser.parseFormData(formData)
    }

    public retrieveUnitString (length?: Height | Diameter | Mass) {
        if (length) return length.value + length.unit
        return ""
    }

    public calcPrice (ingredients: Ingredient[], currency: Currency) {
        return this.recipe.ingredients.reduce((prev, current) => {
            const ingredientData = ingredients.filter(ingredient => ingredient.name === current.name)
            if (ingredientData.length > 1 || ingredientData.length === 0) return prev
            const massRelation = this.massConverter.convertMass(current.mass, "g") / this.massConverter.convertMass(ingredientData[0].mass, "g")
            return prev + massRelation * this.currencyConverter.convertPrice(ingredientData[0].price, currency)
        }, 0)
    }

    public retrieveListData () {
        const listData: {label: string, value: number, unit: string, translateLabel?: boolean, unitKind?: string}[] = [
            {
                label: "mass",
                unit: this.recipe.mass.unit,
                value: this.recipe.mass.value
            },
            {
                label: "height",
                unit: this.recipe.height.unit,
                value: this.recipe.height.value,
            },
            {
                label: "diameter",
                unit: this.recipe.diameter.unit,
                value: this.recipe.diameter.value,
            }
        ]
        this.recipe.ingredients.forEach(ingredient => {
            listData.push({
                label: ingredient.name,
                unit: ingredient.mass.unit,
                value: ingredient.mass.value,
                translateLabel: false,
                unitKind: "mass"
            })
        })
        return listData
    }

    public retrieveHeightAndDiameterTags() {
        const tags: string[] = []
        const heightTag = this.recipe.height ?  "Height: " + this.retrieveUnitString(this.recipe.height) : ""
        const diameterTag = this.recipe.diameter ? "Diameter: " + this.retrieveUnitString(this.recipe.diameter) : ""
        if (heightTag) tags.push(heightTag)
        if (diameterTag) tags.push(diameterTag)
        return tags
    }

    public retrieveTags() : string[] {
        const tags: string[] = []
        const massTag = this.recipe.mass ? "Mass: " + this.retrieveUnitString(this.recipe.mass) : ""
        if (massTag) tags.push(massTag)
        return [...tags, ...this.retrieveHeightAndDiameterTags()]
    }

    hasSameName = (formData: any) => formData["name"] === this.recipe.name

    toFormData = () => this.recipeParser.parseRecipe(this.recipe)

    copy = () => JSON.parse(JSON.stringify(this.recipe))
}
